import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography,ContentLoader } from '@dev/ee-components';
import { Box } from '@material-ui/core';
import { useLandingPageSubdomain } from '../../hooks/useLandingPageSubdomain';

export const Step3Content = (): JSX.Element => {
    const { t } = useTranslation();
    const {landingPageSubdomain,loading} = useLandingPageSubdomain() || {}

    return (
        <>
            <Typography variant="h3">{t('productpagelink')}:</Typography>
            <Box mt="8px" />
            <Typography variant="body1" style={{wordBreak: "break-all"}}>{loading ? <ContentLoader mode="row" /> : landingPageSubdomain?.Url || ''}</Typography>
        </>
    );
};
